module.exports = __webpack_public_path__ + "img/dd86444.PNG";